import React from 'react';

const Loader = ({overlay}) => {
    {
        return overlay ? (
            <div className="loader-overlay">
                <ul className="loader">
                    <li />
                    <li />
                    <li />
                </ul>
            </div>
        ) : (
            <ul className="loader">
                <li />
                <li />
                <li />
            </ul>
        );
    }
};

export default Loader;
